import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

// Custom hook to handle Premium navigation
export const usePremiumNavigation = () => {
  const { userType, subscriptionStatus, userId } = useContext(AuthContext);

  const getPremiumLink = () => {
    // If user is not logged in, go to payment page
    if (!userId) {
      return "/payment";
    }

    // If user has active premium subscription, go to questions overview
    if (userType === "premium" && subscriptionStatus === "active") {
      return "/questionsoverview";
    }

    // For all other cases (basic user, no subscription, inactive subscription), go to payment
    return "/payment";
  };

  const isPremiumUser = () => {
    return userId && userType === "premium" && subscriptionStatus === "active";
  };

  return {
    getPremiumLink,
    isPremiumUser,
  };
};
